import { connect } from 'react-redux'

import { redirect } from 'actions/redirect'
import { userGetReferralDetails } from 'actions/user'

import { ReferAFriendWrapper } from './ReferAFriend'

type State = {
  user: {
    get: (key: string) => any
  }
}

type StateProps = {
  referralDetails: any
}

type DispatchProps = {
  userGetReferralDetails: typeof userGetReferralDetails
  redirect: typeof redirect
}

function mapStateToProps(state: State): StateProps {
  return {
    referralDetails: state.user.get('referralDetails'),
  }
}

export const ReferAFriendContainer = connect<StateProps, DispatchProps, unknown, State>(
  mapStateToProps,
  {
    userGetReferralDetails,
    redirect,
  },
)(ReferAFriendWrapper)
